// armarItems arma los ítems del carrito con lo elegido por tarifa.
// respuestas son las del formulario de información adicional, por
// `${idtarifa}-${indiceTicket}`. Una tarifa con varias mesas va en un ítem por
// mesa y cada uno se lleva las respuestas de sus tickets.
export const armarItems = ({ tarifas, cantidad, asientosSeleccionados, respuestas = {} }) => {
  const items = [];

  Object.entries(cantidad).forEach(([idt, cantidadTotal]) => {
    if (!cantidadTotal || cantidadTotal <= 0) return;
    const idtarifa = parseInt(idt, 10);
    const tarifa = tarifas.find((t) => t.id === idtarifa);
    const datos = asientosSeleccionados[idt] || { asientos: [], mesas: {} };
    const asientos = datos.asientos || [];
    const esMesaNoNumerada = tarifa?.ubicacion?.tipo_ubicacion === 2;
    const esPreimpreso = tarifa?.preimpreso === true;
    const metadata = datos.metadata?.precioMesa ? datos.metadata : null;

    const respuestasDe = (desde, hasta) => {
      const lista = [];
      for (let i = desde; i < hasta; i++) {
        Object.entries(respuestas[`${idt}-${i}`]?.respuestas || {}).forEach(([pregunta, respuesta]) => {
          lista.push({ id_informacion_adicional: parseInt(pregunta, 10), respuesta: respuesta || "" });
        });
      }
      return lista;
    };

    const mesas = Object.entries(datos.mesas || {});
    if (mesas.length > 0) {
      let desde = 0;
      mesas.forEach(([idmesa, cantidadMesa], indice) => {
        const item = {
          idtarifa,
          cantidad: cantidadMesa,
          respuestas: respuestasDe(desde, desde + cantidadMesa),
          idmesa: parseInt(idmesa, 10),
        };
        desde += cantidadMesa;
        if (datos.paquetes?.[idmesa]) item.idpaquete = datos.paquetes[idmesa];
        if (asientos.length > 0) {
          const asiento = [asientos[indice]];
          item.asientos_seleccionados = JSON.stringify(metadata ? { asientos: asiento, metadata } : asiento);
        } else if (esPreimpreso && !esMesaNoNumerada) {
          item.asientos_seleccionados = JSON.stringify([]);
        }
        items.push(item);
      });
      return;
    }

    const item = { idtarifa, cantidad: cantidadTotal, respuestas: respuestasDe(0, cantidadTotal), idmesa: null };
    if (metadata) {
      item.asientos_seleccionados = JSON.stringify({ asientos, metadata });
    } else if (asientos.length > 0) {
      item.asientos_seleccionados = JSON.stringify(asientos);
    } else if (esPreimpreso) {
      item.asientos_seleccionados = JSON.stringify([]);
    }
    items.push(item);
  });

  return items;
};
